export default "__VITE_PUBLIC_ASSET__698867c7__"